
import React from "react";
import { Textarea } from "@/components/ui/textarea";
import { MessageSquare } from "lucide-react";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";

interface SermonNotesFieldProps {
  form: UseFormReturn<any>;
}

export function SermonNotesField({ form }: SermonNotesFieldProps) {
  return (
    <FormField
      control={form.control}
      name="notes"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="flex items-center">
            <MessageSquare className="w-4 h-4 mr-2" />
            Sermon Notes
          </FormLabel>
          <FormControl>
            <Textarea
              placeholder="Enter additional notes, thoughts or ideas for this sermon"
              {...field}
              rows={6}
              className="min-h-[120px] focus:ring-2 focus:ring-primary-500 focus:ring-offset-1 ring-offset-background"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
